import { render, staticRenderFns } from "./shopAdd.vue?vue&type=template&id=c42071dc&scoped=true"
import script from "./shopAdd.vue?vue&type=script&lang=js"
export * from "./shopAdd.vue?vue&type=script&lang=js"
import style0 from "./shopAdd.vue?vue&type=style&index=0&id=c42071dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42071dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c42071dc')) {
      api.createRecord('c42071dc', component.options)
    } else {
      api.reload('c42071dc', component.options)
    }
    module.hot.accept("./shopAdd.vue?vue&type=template&id=c42071dc&scoped=true", function () {
      api.rerender('c42071dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/shopList/shopAdd.vue"
export default component.exports